/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Inspector_EmptyInputs */

const cs_builder_inspector_empty = /** @type {(inputs: Builder_Inspector_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte blok pro úpravu vlastností.`)
};

const en_builder_inspector_empty = /** @type {(inputs: Builder_Inspector_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a block to edit props.`)
};

/**
* | output |
* | --- |
* | "Select a block to edit props." |
*
* @param {Builder_Inspector_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_inspector_empty = /** @type {((inputs?: Builder_Inspector_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Inspector_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_inspector_empty(inputs)
	return cs_builder_inspector_empty(inputs)
});